import { render } from "./Clickable.vue?vue&type=template&id=7fbde57e&scoped=true&ts=true"
import script from "./Clickable.vue?vue&type=script&lang=tsx"
export * from "./Clickable.vue?vue&type=script&lang=tsx"

import "./Clickable.vue?vue&type=style&index=0&id=7fbde57e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/The-Jojo-Tree/The-Jojo-Tree/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbde57e"]])

export default __exports__